/// <reference path="../../../../../rcwebmodels/bapliefiledata.cs.d.ts" />
import * as React from 'react';
import $ from 'jquery';

import { RCUtils } from './../../RCUtils';
import Dropzone from 'react-dropzone';
import { PopupWindow } from '../sharedcomponents/PopupWindow';
import * as RCNGWindow from './../sharedcomponents/ConfirmationWindow';
import { AgGridReact } from 'ag-grid-react';

import Formatters from '../../actions/Formatters';
var Config: any = require('../../Config.json');
var baplieColumns;

interface fileState {
    files: any[];
    formValue: number;
    baplieData: server.BaplieFileData;
    okMethod: Function;
    cancelMethod: Function;
    confirmationMsg: string;
    VesselID: string;
    VoyageCode: string;
    PortOfDeparture: string;
    PortOfDestination: string;    
}

const emptyBaplieData = {
    VesselID: '',
    VoyageCode: '',
    PortOfDeparture: '',
    PortOfDestination: '',
    IsParsingSuccess: false,
    ReeferData: []
}
var BaplieFileDataFilter: server.BaplieFileData;
var self;
export class BaplieFileUpload extends React.Component<any, fileState> {
    constructor(props: any) {
        super(props);
        this.state = {
            files: [], formValue: 1, baplieData: emptyBaplieData, okMethod: Function, cancelMethod: Function, confirmationMsg: '',
            VoyageCode: '', VesselID: '', PortOfDestination: '', PortOfDeparture: ''

        };
        baplieColumns = this.createColumnDefs();
        self = this;
    }

    onDrop(files) {
        if (files != null && files.length > 1) {
            PopupWindow.showErrorMessage("Alert", "Please select only one file to upload.");
        }
        else {
            this.setState({
                files: files
            });
        }
    }

    onGridReady(params: any) {
        params.api.gridOptionsWrapper.gridOptions.suppressContextMenu = true;
    }

    createColumnDefs() {
        return [
            { headerName: "Reefer ID", field: "ReeferID", cellRenderer: Formatters.stringTypeFormatter, width: 150 },
            { headerName: "Bay CD", field: "BayCD", cellRenderer: Formatters.stringTypeFormatter, width: 150 },
            { headerName: "Bay Row", field: "BayRow", cellRenderer: Formatters.stringTypeFormatter, width: 140 },
            { headerName: "Bay Tier", field: "BayTier", cellRenderer: Formatters.stringTypeFormatter, width: 140 },
        ];
    }

    uploadBaplieFile() {
        if (this.state.files.length > 0) {
            $('#globalLoader').show();
            var url = Config.ApiBaseUrl + '/api/Vessel/UploadBaplieFile';
            var formData = new FormData();
            formData.append("UploadedFile", this.state.files[0]);
            var request = RCUtils.FetchRequest(url, {
                method: 'POST',
                body: formData
            });
            fetch(request)
                .then(RCUtils.handleError)
                .then(response => response.json() as Promise<server.BaplieFileData>)
                .then(data => {
                    if (data != null && data != undefined) {
                        this.setState({
                            formValue: 2, baplieData: data, VoyageCode: data.VoyageCode, VesselID: data.VesselID, PortOfDestination: data.PortOfDestination, PortOfDeparture: data.PortOfDeparture

                        });
                       
                       
                        
                        
                    }
                    else {
                        PopupWindow.showErrorMessage("Error", "There is no data to export.");
                    }
                    $('#globalLoader').hide();
                });
        }
        else {
            PopupWindow.showErrorMessage("Error", "Please select a file to upload.");
        }
    }

    finishUpload() {
        if (this.state.VesselID == '' || this.state.VesselID == null) {
            PopupWindow.showErrorMessage("Alert", "Please enter the VesselID.");
        } else if (this.state.VoyageCode == '' || this.state.VoyageCode == null) {
            PopupWindow.showErrorMessage("Alert", "Please enter the VoyageCode.");
        } else if (this.state.PortOfDeparture == '' || this.state.PortOfDeparture == null) {
            PopupWindow.showErrorMessage("Alert", "Please enter Departure.");
        } else if (this.state.PortOfDestination == '' || this.state.PortOfDestination == null) {
            PopupWindow.showErrorMessage("Alert", "Please enter Destination.");
        } else {
            $('#globalLoader').show();
            var url = Config.ApiBaseUrl + '/api/Vessel/SubmitBaplieFile';
            BaplieFileDataFilter = {
                VesselID: this.state.VesselID, VoyageCode: this.state.VoyageCode, PortOfDeparture: this.state.PortOfDeparture, PortOfDestination: this.state.PortOfDestination,
                ReeferData: this.state.baplieData.ReeferData, IsParsingSuccess: true
            }
            var request = RCUtils.FetchRequest(url, {
                method: 'POST',
                headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
                //body: JSON.stringify(this.state.baplieData)
                body: JSON.stringify(BaplieFileDataFilter)
            });

            fetch(request)
                .then(RCUtils.handleError)
                .then(response => response.json())
                .then(data => {
                    $('#globalLoader').hide();
                    if (data == 'Vessel information already exists. Do you want to overwrite?') {
                        RCNGWindow.ConfirmWindow.showConfirmBox("Vessel information already exists. Do you want to overwrite?", this.finalSubmit.bind(this), this.closeConfirmation.bind(this));
                    }
                    else {
                        $("#confirmPopUpModel .btn-close").click();
                        this.props.refreshVesselData();
                        // this.props.loadDataOfBaplie(this.state.baplieData);
                        PopupWindow.showErrorMessage("File Status", data);
                        this.closeBapliestate();
                    }
                });
        }
    }

    finalSubmit() {
        RCNGWindow.ConfirmWindow.close();
        $('#globalLoader').show();


        var url = Config.ApiBaseUrl + '/api/Vessel/UpdateBaplieData';
        var request = RCUtils.FetchRequest(url, {
            method: 'POST',
            headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
            //WI-23110
            //body: JSON.stringify(this.state.baplieData)
             body: JSON.stringify(BaplieFileDataFilter)
        });

        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json())
            .then(data => {
                $('#globalLoader').hide();
                $("#confirmPopUpModel .btn-close").click();
                //this.props.loadDataOfBaplie(this.state.baplieData);               
                this.closeBapliestate();
                PopupWindow.showErrorMessage("File Status", data);
            });
    }

    static ClearBapieStateData() {
        self.closeBapliestate();
    }

    clearBaplieState() {
        RCNGWindow.ConfirmWindow.showConfirmBox("You are going to exit.Are you sure you want to continue?", this.closeBapliestate.bind(this), this.closeConfirmation.bind(this));
    }

    closeBapliestate() {
        this.setState({ files: [], formValue: 1, baplieData: emptyBaplieData });
        RCNGWindow.ConfirmWindow.close();
        $("#confirmPopUpModel").css("display", "none");
        $('#btnCloseBaplie').click();
    }

    closeConfirmation() {
        $("#confirmPopUpModel").css("display", "none");
    }

    VesselIDChange(event: React.FormEvent<HTMLInputElement>) {
        var Value: string = event.currentTarget.value;
        this.setState({ VesselID: Value });
    }

    VoyageIDChange(event: React.FormEvent<HTMLInputElement>) {
        var Value: string = event.currentTarget.value;
        this.setState({ VoyageCode: Value });
    }

    PortOfDepartureChange(event: React.FormEvent<HTMLInputElement>) {
        var Value: string = event.currentTarget.value;
        this.setState({ PortOfDeparture: Value });
    }

    PortOfDestinationChange(event: React.FormEvent<HTMLInputElement>) {
        var Value: string = event.currentTarget.value;
        this.setState({ PortOfDestination: Value });
    }

    onClickBackHandler() {
        this.setState({
            formValue: 1
        });
    }

    public render() {
        return <div>
                    <div id='divMsboxDynamicContent1'></div>
                        <div className="modal-body">
                            {
                                this.state.formValue == 1 ? <div id='UploadForm' className="row">
                                    <div className='col-lg-12'>
                                        <div className='input-group'>
                                            <div>
                                                <Dropzone onDrop={this.onDrop.bind(this)} className="dropzone">
                                                    <div className='dropzone-text'> Please click here or drag files to upload </div>
                                                </Dropzone>
                                            </div>
                                        </div>
                                        <div className="alert alert-success mt-2">
                                            <strong>Dropped files</strong>
                                            <ul>
                                                {
                                                    this.state.files.map(f => <li key={f.name}>{f.name} - {f.size} bytes</li>)
                                                }
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                    :
                                    <div>
                                        <div className='well'>
                                            <div className='row'>
                                                <div className='col-md-2 px-0'>
                                                    <span className='col-form-label mandatory-label'>Vessel ID:</span>
                                                </div>
                                                <div className='col-md-4'>
                                                    <input type='text' id='txtVesselID' value={this.state.VesselID}
                                                        onChange={e => this.VesselIDChange(e)} className='form-control' />
                                                </div>
                                                <div className='col-md-2 px-0'>
                                                    <span className='col-form-label mandatory-label'>Voyage ID:</span>
                                                </div>
                                                <div className='col-md-4'>
                                                    <input type='text' id='txtVoyageID' className='form-control' value={this.state.VoyageCode}
                                                        onChange={e => this.VoyageIDChange(e)} />
                                                </div>
                                            </div>
                                            <div className='row mt-2'>
                                                <div className='col-md-2 px-0'>
                                                    <span className='col-form-label mandatory-label'>Port of Departure:</span>
                                                </div>
                                                <div className='col-md-4'>
                                                    <input type='text' id='txtPortofDeparture' className='form-control' value={this.state.PortOfDeparture}
                                                        onChange={e => this.PortOfDepartureChange(e)} />
                                                </div>
                                                <div className='col-md-2 px-0'>
                                                    <span className='col-form-label mandatory-label'>Port of Destination:</span>
                                                </div>
                                                <div className='col-md-4'>
                                                    <input type='text' id='txtPortofDestination' className='form-control' value={this.state.PortOfDestination}
                                                        onChange={e => this.PortOfDestinationChange(e)} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="ag-theme-fresh baplie-grid mt-2" id='BaplieGrid'>
                                            <AgGridReact
                                                columnDefs={baplieColumns}
                                                rowData={this.state.baplieData.ReeferData}
                                                onGridReady={this.onGridReady}                                               
                                                enableRangeSelection={true}
                                                pagination={true}
                                                paginationPageSize={50}>
                                            </AgGridReact>
                                        </div>
                                    </div>
                            }
                        </div>
                        <div className='modal-footer'>
                            {
                                this.state.formValue == 1 ?
                                    <button type="button" className="btn btn-secondary" onClick={this.uploadBaplieFile.bind(this)}>Next</button>
                                    : ''}
                            {this.state.formValue == 2 ? <button type='button' onClick={this.onClickBackHandler.bind(this)} className='btn btn-primary'>Back</button> : ''}
                            {this.state.formValue == 2 ? <button type="button" className="btn btn-primary" onClick={this.finishUpload.bind(this)}>Finish</button> : ''}
                            <button type="button" className="btn btn-primary" onClick={this.clearBaplieState.bind(this)} data-bs-target="#confirmPopUpModel">Cancel</button>
                        </div>
                    </div>
    }
}